import React from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {DeleteCountry} from "./Buttons"


const Country = ({data}) => {

  let navigate = useNavigate()
  let location = useLocation()
  let params = useParams()  
	const Datas = data.find((county) => county.population === parseInt(params.countryId,10));

  
  return (
    <section className="leading-relaxed text-slate-100 relative py-[300px] card-wrapper prose-sm tracking-widest">
      <div className="max-w-[60ch] wx-auto rounded-sm sticky top-[5%] mx-auto overflow-hidden pt-[12rem] card"
      style={{
        backgroundImage: `url(${Datas.flag})`,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
      }}
      >
      <div className="p-6 cardContent">
      <div className="max-w-md hidden transition delay-1000 ease-in-out imgFlage">
        <img src={Datas.flag}  alt="flags"  className="w-full h-52"/>
      </div>
      <h1 className="cardTitle relative w-max">{Datas.name}</h1>
      <div className="text-slate-50 / 0.85 text-lg">
      <p className="my-0">
						{Datas.capital.length > 0 ? (
							<>
								<strong>Capital: </strong>
								{Datas.capital}
							</>
						) : (
							""
						)}
					</p>
          <p className="my-0">
						<strong>
							{Datas.languages.length > 1 ? `Languages` : `language`}:{" "}
						</strong>
						{Datas.languages.join(",")}
					</p> 
          <p className="my-0">
						<strong>Population:</strong> {Datas.population}
					</p>
					<p className="mt-0">
						<strong>Currency:</strong>{" "}
						{Datas.currencies ? Datas.currencies[0].name : Datas.currency}, <span className="mt-3"> {Datas.currencies ? Datas.currencies[0].symbol: ""} </span>
            
					</p>
      </div>
      <button 
      onClick={() => {
        DeleteCountry(data, Datas.population)
        navigate("/countries" + location.search)
      }}
      className="button"
      >
        delete
      </button>
      </div>
      </div>
    </section>
  )
}




export default Country